import { ActionReducer, createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { IUserAuthProfile } from '../../core/services/auth.service';
import { AUTH_ACTIONS } from '../actions';

export const AUTH_STATE_KEY = 'auth';

export interface IAuthState {
  authenticated: boolean;
  discoveryDocumentLoaded: boolean;
  userProfileLoaded: boolean;
  userProfile: IUserAuthProfile;
}

export const initialState: IAuthState = {
  authenticated: false,
  discoveryDocumentLoaded: false,
  userProfileLoaded: false,
  userProfile: {} as IUserAuthProfile,
};

const reducer: ActionReducer<IAuthState> = createReducer<IAuthState>(
  initialState,
  on(
    AUTH_ACTIONS.initLoginCheck,
    (state): IAuthState => ({
      ...state,
      discoveryDocumentLoaded: false,
      userProfileLoaded: false,
    }),
  ),
  on(
    AUTH_ACTIONS.authenticated,
    (state): IAuthState => ({
      ...state,
      authenticated: true,
    }),
  ),
  on(
    AUTH_ACTIONS.notAuthenticated,
    (state): IAuthState => ({
      ...state,
      authenticated: false,
      discoveryDocumentLoaded: false,
      userProfileLoaded: false,
      userProfile: {} as IUserAuthProfile,
    }),
  ),
  on(
    AUTH_ACTIONS.login,
    (state): IAuthState => ({
      ...state,
      authenticated: false,
    }),
  ),
  on(
    AUTH_ACTIONS.discoveryDocumentLoaded,
    (state): IAuthState => ({
      ...state,
      discoveryDocumentLoaded: true,
    }),
  ),
  on(
    AUTH_ACTIONS.userProfileLoaded,
    (state, { userProfile }): IAuthState => ({
      ...state,
      userProfileLoaded: true,
      userProfile,
    }),
  ),
  on(
    AUTH_ACTIONS.logout,
    (state): IAuthState => ({
      ...state,
      ...initialState,
    }),
  ),
);

export const AUTH_REDUCER = createFeature({
  name: AUTH_STATE_KEY,
  reducer,
  extraSelectors: ({ selectUserProfile }) => ({
    userId: createSelector(selectUserProfile, ({ 'user-id': userId }): number => Number(userId)),
    userName: createSelector(selectUserProfile, ({ preferred_username }): string => preferred_username),
  }),
});
